import api from 'core/api';

export const updateUser = ({ id, user }) => api.put(`/users/${id}`, user);
export const spotifyAccount = (params) => api.post('/users/create_spotify_account', params);
export const deleteSpotifyAccount = (id) => api.delete(`/users/remove_spotify_account/${id}`);
export const workoutInvites = (userId) => api.get(`/workouts_users/${userId}/invites`);
export const connectAccount = (userId, code) =>
  api.get(`/users/${userId}/connect_stripe_account/${code}`);
export const removeAccount = (userId) => api.delete(`/users/${userId}/remove_stripe_account`);
